const mainCarousel = new Flickity('.mega-menu--carousel');

const navCarousel = document.querySelector('.carousel-nav--desktop');
const navCells = navCarousel.querySelectorAll('.nav-tab--desktop');

navCells.forEach((cell, index) => {
  cell.addEventListener('mouseover', () => {
    mainCarousel.select(index);
  });
});


document.querySelectorAll("details").forEach((detail) => {
  detail.addEventListener("toggle", () => {
    if (detail.open) {
      const carousels = detail.querySelectorAll(".carousel");
      carousels.forEach((carousel) => {
        const flickityInstance = Flickity.data(carousel);
        if (flickityInstance) {
          // Recalculate dimensions and refresh Flickity
          flickityInstance.resize();
        } else {
          // Initialize Flickity if not already initialized
          new Flickity(carousel, {
            pageDots: false,
            prevNextButtons: false,
            contain: true,
          });
        }
      });
    }
  });
});